import define from "./define";

export const plans = {
  button_select_plan: "Select Plan",

  plan: "Plan",
  price: "",
  free: define.free,
  nonprofit: define.nonprofit,
  professional: define.professional,
  team: define.team,
  teamplus: define.teamplus,
  enterprise: define.enterprise,

  plan_tooltip_monthly: "%s Plan. USD %d / month or USD %d / year.",
  plan_tooltip_yearly: "%s Plan. USD %d / year.",

  eligibility: "Eligibility",
  eligibility_tooltip:
    "Who is eligable to sign up for an account of specific type?",
  traffic: "Traffic",
  traffic_tooltip: "How much traffic (clicks / hits) is included per onelink?",
  lifetime: "Link Lifetime",
  lifetime_tooltip: "How long time will the onelink be active?",
  editing: "Editing",
  editing_tooltip:
    "For how long time and how many times can the download links connected to an onelink be edited?",
  adfree: "Ad-Free *",
  adfree_tooltip:
    "Will the persons clicking on the link have an Advertisement-Free experience?\n\n* Onelinks created on our legacy platform and transferred to the current platform will be Ad-Free indefinitely.",
  urlCount: "Link Count",
  urlCount_tooltip: "How many onelinks can be active at any time?",
  customURLs: "Custom Links",
  customURLs_tooltip:
    "Can the onelink code/URL be customized? E.g. https://onelink.to/my-custom-link",
  userCount: "User Count",
  userCount_tooltip: "How many user (logins) can be connected to the account?",
  parameterForwarding: "Parameter Forwarding",
  parameterForwarding_tooltip:
    "Parameter forwarding enables you to have URL parameters (query string parameters) forwarded with the redirect",
  stats: "Statistics",
  statsDevice: "Device Stats",
  statsDevice_tooltip: "Statistics of device type",
  statsRedirect: "Redirect Stats",
  statsRedirect_tooltip: "Statistics of forward/redirect link",
  statsCountry: "Country Stats",
  statsCountry_tooltip: "Statistics of country origin of hit",
  statsReferringDomain: "Referrer Stats",
  statsReferringDomain_tooltip: "Statistics of referring site",
  statsUTM: "UTM Campaigns",
  statsUTM_tooltip: "UTM campaign parameter statistics",
  statsRetention: "Stats Retention",
  statsRetentionHourly: "Hourly Stats",
  statsRetentionHourly_tooltip: "How many days are hourly statistics saved?",
  statsRetentionDaily: "Daily Stats",
  statsRetentionDaily_tooltip: "For how long time are daily statistics saved?",

  unlimited: "Unlimited",
  unlimited_tooltip: "",
  all: "Everyone",
  all_tooltip: "",
  private_non_profit: "Private or Non-Profit",
  private_non_profit_tooltip:
    "Eligible for private customers and Non-Profit organisations.",
  tooltip_yes: "Yes",
  tooltip_no: "No",
  adfree_free: "3 months\n + 1K clicks/month",
  adfree_free_tooltip:
    "Ad-free experience for the first 3 months and then (at least) 1000 first clicks (or QR scans) per month",
  days_30: "30 days",
  days_30_tooltip: "Stats saved for 30 days",
  days_90: "90 days",
  days_90_tooltip: "Stats saved for 90 days",
  two_years: "2 years",
  two_years_tooltip: "Stats saved for 2 years (750 days)",
};
